import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Vortex } from "react-loader-spinner";
import api from "../../../services/AxiosConnection";
import useAuth from "../../../hooks/useAuth";

const UserManagementForm = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await api.get("/users/get-all-users-by-creator", {
          params: { createdBy: user.id },
        });
        setUsers(response.data.users);
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        setLoading(false);
      }
    };

    if (user?.id) {
      fetchUsers();
    }
  }, [user?.id]);

  const handleNavigate = () => {
    navigate("/dashboard/user-management");
  };

  return (
    <div className="p-6 max-w-7xl mx-auto">
      {loading && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <Vortex
            visible={true}
            height={80}
            width={80}
            ariaLabel="vortex-loading"
            wrapperStyle={{}}
            wrapperClass="vortex-wrapper"
            colors={[
              "#2563eb",
              "#1e40af",
              "#60a5fa",
              "#3b82f6",
              "#1d4ed8",
              "#93c5fd",
            ]}
          />
        </div>
      )}
      <div className="flex justify-center items-center mb-8">
        <button
          onClick={handleNavigate}
          className="bg-blue-700 text-white px-6 py-2 rounded-lg hover:bg-blue-800 transition-colors"
        >
          Go to User Management Page
        </button>
      </div>

      <div className="bg-white rounded-xl shadow-lg mb-6">
        <h1 className="text-2xl font-bold text-center py-4">User List</h1>

        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-3 text-center text-xs font-medium text-gray-700 uppercase tracking-wider">
                S.No
              </th>
              <th className="px-4 py-3 text-center text-xs font-medium text-gray-700 uppercase tracking-wider">
                User
              </th>
              <th className="px-4 py-3 text-center text-xs font-medium text-gray-700 uppercase tracking-wider">
                Department
              </th>
              <th className="px-4 py-3 text-center text-xs font-medium text-gray-700 uppercase tracking-wider">
                Designation
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {users.map((user, index) => (
              <tr key={user.id} className="hover:bg-gray-50">
                <td className="px-4 py-3 text-center text-sm text-gray-900">
                  {index + 1}
                </td>
                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 text-center">
                  {user.username?.trim() || "-"}
                </td>
                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-600 text-center">
                  {user.department?.trim() || "-"}
                </td>
                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-600 text-center">
                  {user.designation?.trim() || "-"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UserManagementForm;
